
import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FocusSection from './components/FocusSection';
import ValueSection from './components/ValueSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  useEffect(() => {
    // Smooth scrolling behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="relative">
      {/* Navigation */}
      <Navigation />
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* About Us Section */}
      <AboutSection />
      
      {/* Our Focus Section */}
      <FocusSection />
      
      {/* Our Value Section */}
      <ValueSection />
      
      {/* Contact Section */}
      <ContactSection />
    </div>
  );
}
